import Grid from 'material-ui/Grid'
import * as React from 'react'

export const OfficePhotos = () => {
    return (
        <div style={{maxWidth: 950, margin: 'auto', padding: '70px 10px'}}>
            <Grid container>
                <Grid item xs={12} sm={7}>
                    <div
                        style={{
                            height: 615,
                            width: '100%',
                            background: 'url("/img/office/sizzle.png") no-repeat',
                            backgroundPosition: 'center center',
                            backgroundSize: 'cover'
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={5}>
                    <div style={{height: 615}}>
                        <div
                            style={{
                                height: 300,
                                width: '100%',
                                background: 'url("/img/office/lounge.png") no-repeat',
                                backgroundPosition: 'center center',
                                backgroundSize: 'cover',
                                marginBottom: 15
                            }}
                        />
                        <div
                            style={{
                                height: 300,
                                width: '100%',
                                background: 'url("/img/office/working.png") no-repeat',
                                backgroundPosition: 'center center',
                                backgroundSize: 'cover',
                                marginBottom: 15
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/index/OfficePhotos.tsx